interface BadgeProps {
  children: React.ReactNode;
  color?: string;
  bg?: string;
  className?: string;
}

export default function Badge({ children, color, bg, className = '' }: BadgeProps) {
  return (
    <span
      className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-semibold tracking-wide ${className}`}
      style={{ color, backgroundColor: bg }}
    >
      {children}
    </span>
  );
}
